import { render, staticRenderFns } from "./ReportsQueryWidget.vue?vue&type=template&id=78cc8dc6&scoped=true&"
import script from "./ReportsQueryWidget.vue?vue&type=script&lang=js&"
export * from "./ReportsQueryWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportsQueryWidget.vue?vue&type=style&index=0&id=78cc8dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cc8dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78cc8dc6')) {
      api.createRecord('78cc8dc6', component.options)
    } else {
      api.reload('78cc8dc6', component.options)
    }
    module.hot.accept("./ReportsQueryWidget.vue?vue&type=template&id=78cc8dc6&scoped=true&", function () {
      api.rerender('78cc8dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportsQueryWidget.vue"
export default component.exports